import Link from 'next/link';
import { Fragment } from 'react';
import { topicLabel, topicPath, townPath } from 'utils/directory';
import styles from 'styles/modules/BrokerDirectory.module.scss';

// On a listed broker's profile: their town page and the topic pages they are on.
export default function DirectoryBackLinks({ directory }) {
    const { town, topics = [] } = directory ?? {};
    if (!town && !topics.length) {
        return null;
    }

    return (
        <nav
            className={styles.backLinks}
            aria-label="Mortgage broker directory"
        >
            {town && (
                <p>
                    <Link href={townPath(town.slug)}>
                        <a>More mortgage brokers in {town.name}</a>
                    </Link>
                </p>
            )}
            {topics.length > 0 && (
                <p>
                    Also quoted on:{' '}
                    {topics.map((topic, index) => (
                        <Fragment key={topic.slug}>
                            {index > 0 && ', '}
                            <Link
                                href={topicPath(topic.slug, topic.underTopic)}
                            >
                                <a>{topicLabel(topic.name)}</a>
                            </Link>
                        </Fragment>
                    ))}
                </p>
            )}
        </nav>
    );
}
